import { load } from 'cheerio';
import Provider from '@/enums/Provider';

export function extractProductMainCategory(
    htmlSource: string,
    pathname: string,
    provider: Provider
): string {
    const $ = load(htmlSource);
    let mainCategory = '';

    switch (provider) {
        case Provider.KBS: {
            // Extract the main category href from the anchor tag within the product-details div
            const mainCategoryAnchor = $('.product-details a.btn-warning');
            if (mainCategoryAnchor.length > 0) {
                mainCategory = mainCategoryAnchor.attr('href') || '';
            }
            if (!mainCategory) {
                const mainCategoryAnchor2 = $('.product-details a.btn-custom.color2');
                if (mainCategoryAnchor2.length > 0) {
                    mainCategory = mainCategoryAnchor2.attr('href') || '';
                }
            }
            break;
        }
        case Provider.IO: {
            // Remove trailing slash if present.
            const trimmedPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

            // Now remove the last segment and add a trailing slash back.
            mainCategory = trimmedPath.substring(0, trimmedPath.lastIndexOf('/') + 1);
            break;
        }
        case Provider.ERS:
            break;
        default:
            break;
    }
    return mainCategory;
}